import { MESSAGE_ERREUR_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE, MESSAGE_ERREUR_IDTYPECOMPTE_OBLIGATOIRE, MESSAGE_ERREUR_NOM_OBLIGATOIRE, MESSAGE_ERREUR_PRENOM_OBLIGATOIRE, MESSAGE_ERREUR_SOCIETE_OBLIGATOIRE, MESSAGE_ERREUR_TELEPHONE_OBLIGATOIRE } from '../../data/message-erreurs-form';
import * as Yup from 'yup';
import { telephoneSchemaRequired } from './telephoneSchema';
import { emailSchemaRequired } from './emailSchema';


export const UtilisateurSchemaBO = Yup.object().shape({
  IdCivilite: Yup
  .number()
  .positive()
  .required(MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE)
  .typeError(MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE),
  Email: emailSchemaRequired(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE),
  Nom: Yup
    .string()
    .required(MESSAGE_ERREUR_NOM_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_NOM_OBLIGATOIRE),
  Prenom: Yup
    .string()
    .required(MESSAGE_ERREUR_PRENOM_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_PRENOM_OBLIGATOIRE),
  Telephone: telephoneSchemaRequired(MESSAGE_ERREUR_TELEPHONE_OBLIGATOIRE),
  IdTypeCompte: Yup
  .number()
  .positive()
  .required(MESSAGE_ERREUR_IDTYPECOMPTE_OBLIGATOIRE)
  .typeError(MESSAGE_ERREUR_IDTYPECOMPTE_OBLIGATOIRE),
  IdSociete: Yup
  .number()
  .positive()
  .required(MESSAGE_ERREUR_SOCIETE_OBLIGATOIRE)
  .typeError(MESSAGE_ERREUR_SOCIETE_OBLIGATOIRE),
  });
